import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from "vue";
import store from "@/store";

interface Props {
  initialFromDate: string;
  initialToDate: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DateRangePicker',
  props: {
    initialFromDate: null,
    initialToDate: null
  },
  emits: ["apply-range"],
  setup(__props: any, { emit }: { emit: ({
  (e: "apply-range", payload: { from: Date; to: Date }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  initialFromDate: string;
  initialToDate: string;
}




const today = computed(() => new Date());
const todayStr = today.value.toISOString().substr(0, 10);

const fromDate = ref<string>(props.initialFromDate || "");
const toDate = ref<string>(todayStr);
const maxDate = computed(() => todayStr);

const language = computed(() => store.state.language);

const translations = computed(() => {
  const map: Record<string, { from: string; to: string; apply: string }> = {
    cs: { from: "Od", to: "Do", apply: "Použít" },
    de: { from: "Von", to: "Bis", apply: "Anwenden" },
    en: { from: "From", to: "To", apply: "Apply" },
  };
  return map[language.value] || map.en;
});

const disabled = computed(() => {
  if (!fromDate.value || !toDate.value) return true;
  const from = new Date(fromDate.value);
  const to = new Date(toDate.value);
  return !(from < to && to < today.value);
});

function applyRange() {
  if (fromDate.value && toDate.value) {
    const from = new Date(fromDate.value);
    const to = new Date(toDate.value);
    emit("apply-range", { from, to });
  }
}

watch(
  () => props.initialFromDate,
  (newVal) => {
    fromDate.value = newVal;
  }
);
watch(
  () => props.initialToDate,
  (newVal) => {
    toDate.value = newVal;
  }
);

return { __sfc: true,props, emit, today, todayStr, fromDate, toDate, maxDate, language, translations, disabled, applyRange }
}

})